<template>
  <div style="padding: 15px;">
    <vxe-toolbar
      id="toolbarId_ba1"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button @click="funcFilter">查询</el-button>
        <el-button
          v-if="getLimit('binfCard_export_button')"
          @click="funcExport()"
        >
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      show-footer
      highlight-hover-row
      row-id="id"
      height="400"
      :data="tableData"
      :loading="loading"
      :sort-config="{ remote: true }"
      export-config
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <!-- 绑定状态 -->
      <vxe-table-column>
        <vxe-table-column
          field="bindCardStatus"
          title="绑定状态"
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'bindCardStatus')
          "
          min-width="120"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.bindCardStatus"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in bindCardStatusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="bindCardFailReason"
          title="失败原因"
          min-width="200"
          sortable
        >
          <template slot-scope="scope">
            {{
              scope.row.bindCardStatus == 4 ? scope.row.bindCardFailReason : ""
            }}
          </template>
        </vxe-table-column>
        <template v-slot:header>
          <el-input
            v-model="listQuery.bindCardFailReason"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="isDefault"
          title="是否默认卡"
          :formatter="formatterIsDefault"
          min-width="120"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.isDefault"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in isDefaultOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="gmtCreated"
          title="新增银行卡时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="gmtCreatedRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="bindCardFinishTime"
          title="绑卡完成时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="bindCardFinishRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'bindCardFinishTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="regMerchantBank"
          title="是否是商户注册银行卡"
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'regMerchantBank')
          "
          min-width="180"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.regMerchantBank"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in regMerchantBankOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="name"
          title="开户人名称"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="listQuery.name" placeholder="请输入" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="mobile"
          title="银行预留手机号"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="listQuery.mobile" placeholder="请输入" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="account"
          title="开户银行卡"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.account"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="bankNo"
          title="开户银行"
          :formatter="formatterBank"
          min-width="250"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.bankName"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="province"
          title="开户省份"
          min-width="250"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.province"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="accountCity"
          title="开户城市"
          min-width="250"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.accountCity"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="branche"
          title="开户网点"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.branche"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="bankAssociationNumber"
          title="联行号"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.bankAssociationNumber"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="type"
          title="账户类型"
          :formatter="formatterType"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select v-model="listQuery.type" placeholder="请选择" clearable>
            <el-option
              v-for="item in typeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="gmtModified"
          title="修改时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="gmtModifiedRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtModified')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" width="150" fixed="right">
        <template slot-scope="scope">
          <el-tooltip
            v-if="
              scope.row.bindCardStatus == 0 || scope.row.bindCardStatus == 4
            "
            class="item"
            effect="dark"
            content="绑卡"
            placement="top"
          >
            <vxe-button type="text" @click="bindCard(scope.row.code)">
              <i class="el-icon-s-finance" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="scope.row.bindCardStatus == 3"
            class="item"
            effect="dark"
            content="解绑"
            placement="top"
          >
            <vxe-button type="text" @click="unbindCard(scope.row.code)">
              <i class="el-icon-s-release" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :page-sizes="Pagingconf"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
  </div>
</template>
<script>
import request from "@/utils/request";
import { getListDict } from "@/api/commonApi";
import { bindBankCard, unBindBankCard } from "@/api/bankCard";
export default {
  name: "BindCardList",

  data() {
    return {
      bindCardFinishRange: "",
      gmtCreatedRange: "",
      gmtModifiedRange: "",
      bankList: [],
      loading: false,
      tableData: [],
      branchList: this.$store.state.components.branchList,
      listQuery: {
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0,
        partyCode: ""
      },
      exportObj: {
        exportUrl: "/ntocc-basic-api/bankCard/exportBankCardDetailList", //导出接口
        name: "绑卡管理"
      },
      // 默认卡
      isDefaultOptions: [{ label: "否", value: 0 }, { label: "是", value: 1 }],
      // 注册网商商户
      regMerchantBankOptions: [
        { label: "否", value: 0 },
        { label: "是", value: 1 }
      ],

      // 绑定状态
      bindCardStatusOptions: [
        { label: "未绑卡", value: 0 },
        { label: "绑卡中", value: 1 },
        { label: "待验证", value: 2 },
        { label: "已成功", value: 3 },
        { label: "已失败", value: 4 }
      ],
      // // 账户类型
      typeOptions: [
        { label: "个人账户", value: 1 },
        { label: "企业账户", value: 2 }
      ],

      roleOptions: [
        //{ label: "超级管理员", value: 'SUPER_ADMIN' },
        //{ label: "平台管理员", value: 'PLAT_ADMIN' },
        { label: "实际承运人", value: "DRIVER" },
        { label: "车队长", value: "DRIVER_LEADER" },
        { label: "个体托运人", value: "SHIPMENT" },
        { label: "企业托运人", value: "SHIPMENT_COMPANY" }
        //{ label: "员工", value: 'STAFF' },
        //{ label: "加油站", value: 'GAS_STATION' },
        //{ label: "住户", value: 'HOUSEHOLD' }
      ]
    };
  },

  watch: {
    "$store.state.components.branchList": function() {
      this.$refs.xTable.updateData();
    }
  },
  created() {
    this.findList();
    // 获取数据字典： 银行
    getListDict({ types: "bank" }).then(response => {
      this.bankList = response.data.filter(item => item.type === "bank")[0][
        "dictList"
      ];
      this.findList();
    });
  },
  methods: {
    async RefreshList() {
      const partyCode = this.listQuery.partyCode;
      this.listQuery = {
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0,
        partyCode
      };
      await this.findList();
    },
    getInfo(partyCode) {
      this.gmtCreatedRange = [];
      this.bindCardFinishRange = [];
      this.gmtModifiedRange = [];
      this.$set(this, "listQuery", {
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0,
        partyCode
      });
      this.findList();
    },
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        request({
          url: "/ntocc-basic-api/bankCard",
          method: "get",
          params: this.listQuery
        }).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.loading = false;
          resolve();
        });
      });
    },
    bindCard(code) {
      this.$confirm("确认进行绑卡吗？").then(_ => {
        bindBankCard(code).then(response => {
          this.$message({ message: response.msg, type: "success" });
          this.findList();
        });
      });
    },
    // 删除方法
    unbindCard(code) {
      this.$confirm("确认进行解绑吗？").then(_ => {
        unBindBankCard(code).then(response => {
          this.$message({ message: response.msg, type: "success" });
          this.findList();
        });
      });
    },

    // 翻译是否默认
    formatterIsDefault({ cellValue }) {
      const item = this.isDefaultOptions.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    formatterRole({ cellValue }) {
      const item = this.roleOptions.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    formatterField({ cellValue }, prefix) {
      const item = this[`${prefix}Options`].find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    // 翻译账户类型
    formatterType({ cellValue }) {
      const item = this.typeOptions.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    // 翻译开户银行
    formatterBank({ cellValue }) {
      const item = this.bankList.find(item => item.code === cellValue);
      return item ? item.name : "";
    },

    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item => item.code === cellValue);
      return item ? item.groupName : "";
    }
  }
};
</script>
